import axios from 'axios'
import { API_BASE } from '../config'

function authHeaders() {
    return { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } };
}

export default class News {
    // GET /news - Returns all news posts, newest first
    getNews() {
        return axios.get(`${API_BASE}/news`).then(x => x.data);
    }

    // The rest are for Staff and above

    // POST /news - Publish a post: { success, post }
    addPost(title, body) {
        return axios.post(`${API_BASE}/news`, { title, body }, authHeaders()).then(x => x.data);
    }

    // PUT /news/:id - Change a post's title and text: { success, post }
    editPost(id, title, body) {
        return axios.put(`${API_BASE}/news/${encodeURIComponent(id)}`, { title, body }, authHeaders()).then(x => x.data);
    }

    // DELETE /news/:id - Delete a post for good: { success }
    deletePost(id) {
        return axios.delete(`${API_BASE}/news/${encodeURIComponent(id)}`, authHeaders()).then(x => x.data);
    }

}
